module.exports = __webpack_public_path__ + "img/monitoring-bus-green.c66f9c38.svg";